'use client';

import { useEffect } from 'react';

import { useTranslations } from 'next-intl';
import { usePrevious } from 'react-use';
import { toast } from 'sonner';

import { useToasterId } from '@/components/toaster-context';
import { useTtsPlaybackErrors } from '@/lib/tts/tts-signal';

const TOAST_ID = 'tts-playback-error';

export function TtsPlaybackErrorMonitor() {
  const t = useTranslations();
  const playbackErrors = useTtsPlaybackErrors();
  const previous = usePrevious(playbackErrors);
  const toasterId = useToasterId();

  // Guard on the increase, not just on the effect firing: the counter is global
  // and never resets, so mounting must stay quiet, and a locale or toaster change
  // must not be mistaken for a new failure.
  useEffect(() => {
    if (previous === undefined || playbackErrors <= previous) return;
    toast.error(t('thread.tooltips.audioPlaybackError'), { id: TOAST_ID, toasterId });
  }, [playbackErrors, previous, t, toasterId]);

  return null;
}
